import { render } from "./CollectionsReportPage.vue?vue&type=template&id=062c6a85&scoped=true"
import script from "./CollectionsReportPage.vue?vue&type=script&lang=js"
export * from "./CollectionsReportPage.vue?vue&type=script&lang=js"

import "./CollectionsReportPage.vue?vue&type=style&index=0&id=062c6a85&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062c6a85"]])

export default __exports__